<dx-popup
    title="Job Times"
    [width]="800"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dx-data-grid
        #jobTimeGrid
        keyExpr="id"
        class="d-flex flex-fill flex-column"
        [dataSource]="jobTimes"
        style="min-height: 650px; min-width: 750px"
        (onToolbarPreparing)="onToolbarPreparing($event)"
    >
        <dxi-data-grid-column dataField="started" width="200" dataType="date" format="MM/dd/yyyy hh:mm aa"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="completed" width="200" dataType="date" format="MM/dd/yyyy hh:mm aa"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="totalMinutes" width="200"></dxi-data-grid-column>
        <dxi-data-grid-column></dxi-data-grid-column>
        <div *dxTemplate="let data of 'toolbarButtons'">
            <button
                class="btn btn-primary ms-2"
                (click)="editStart(jobTimeGrid.instance.getSelectedRowsData()[0])"
                [disabled]="jobTimeGrid.instance.getSelectedRowsData().length !== 1"
            >
                Edit Start Time
            </button>
            <button
                class="btn btn-primary ms-2"
                (click)="editCompleted(jobTimeGrid.instance.getSelectedRowsData()[0])"
                [disabled]="jobTimeGrid.instance.getSelectedRowsData().length !== 1"
            >
                Edit Complete Time
            </button>
            <button
                class="btn btn-danger ms-2"
                (click)="deleteTime(jobTimeGrid.instance.getSelectedRowsData()[0])"
                [disabled]="jobTimeGrid.instance.getSelectedRowsData().length !== 1"
            >
                Delete
            </button>
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
            <span class="me-3">
                <strong>{{ jobTimeGrid.instance.totalCount() + ' items' }}</strong>
            </span>
        </div>
        <dxo-data-grid-selection [mode]="'single'"></dxo-data-grid-selection>
    </dx-data-grid>
</dx-popup>
